<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="white--text primary"
        >SỬA LỚP BÁN TRÚ {{ item.name }}
        <v-spacer />
        <v-icon color="white" @click="closeDialog">close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form" class="pt-6">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                label="Tên lớp bán trú"
                placeholder="Nhập tên lớp bán trú"
                hide-details="auto"
                outlined
                dense
                class="required"
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="status"
                :items="[
                  { title: 'Đang hoạt động', status: 'active' },
                  { title: 'Đã ngưng', status: 'inactive' },
                ]"
                clear-icon="mdi-close"
                item-text="title"
                item-value="status"
                label="Chọn tình trạng"
                hide-details="auto"
                outlined
                dense
                clearable
                class="required"
                :rules="[$rules.required]"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea v-model="notes" label="Mô tả chi tiết" hide-details="auto" outlined></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="px-6">
        <v-btn class="px-6" outlined light depressed @click="closeDialog">Hủy</v-btn>
        <v-spacer />
        <v-btn class="px-6" depressed color="primary" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

function findSpecificChanges(obj1, obj2) {
  const changes = {}

  for (const key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if (!obj1.hasOwnProperty(key) || obj1[key] !== obj2[key]) {
        changes[key] = obj2[key]
      }
    }
  }

  return changes
}

export default {
  data() {
    return {
      dialog: false,
      id: '',
      name: '',
      status: '',
      notes: '',
    }
  },
  computed: { ...mapGetters({ item: 'boardingClass/item' }) },
  methods: {
    ...mapActions('boardingClass', ['update']),
    openDialog(item) {
      this.id = item.id
      this.name = item.name
      this.status = item.status
      this.notes = item.notes
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async save() {
      if (!this.$refs.form.validate()) return
      this.$loading.active = true
      const data = findSpecificChanges(
        { name: this.item.name, status: this.item.status, notes: this.item.notes },
        { name: this.name, status: this.status, notes: this.notes }
      )
      await this.update({ id: this.id, ...data })
      
      this.$loading.active = false
      this.dialog = false
    },
  },
}
</script>
